__turbopack_context__.v({
  "caption": "HeroSectionV2-module__xgEysG__caption",
  "contentWrapper": "HeroSectionV2-module__xgEysG__contentWrapper",
  "ctaButton": "HeroSectionV2-module__xgEysG__ctaButton",
  "hsaBanner": "HeroSectionV2-module__xgEysG__hsaBanner",
  "playPauseBg": "HeroSectionV2-module__xgEysG__playPauseBg",
  "playPauseButton": "HeroSectionV2-module__xgEysG__playPauseButton",
  "playPauseIcon": "HeroSectionV2-module__xgEysG__playPauseIcon",
  "sectionContainer": "HeroSectionV2-module__xgEysG__sectionContainer",
  "title": "HeroSectionV2-module__xgEysG__title",
  "topSection": "HeroSectionV2-module__xgEysG__topSection",
  "videoContainer": "HeroSectionV2-module__xgEysG__videoContainer",
});
